import { WebAPI } from "../constants";
import AuthService from "../../common/AuthService";
import download, { ICallbackParams } from "./downloadCommon";

export interface IDownloadProfileParams extends ICallbackParams {
  /**
   * 認証オブジェクト
   */
  authService?: AuthService;
  /**
   * プロジェクトID
   */
  projectid: string;
  /**
   * 作成ファイル名
   */
  filename: string;
}

/**
 * プロファイルをダウンロードします
 * @function downloadProfile
 * @param {IDownloadProfileParams} params - プロファイルダウンロードパラメータ
 */
export function downloadProfile(params: IDownloadProfileParams): void {
  const { authService, projectid, filename } = params;
  const url = WebAPI.DOWNLOAD_PROFILE(projectid);
  download(url, filename, params, authService);
}
